import { enableEditionProposal } from 'common/api/v1/proposals';
import { showReponseErrorsAsAlert } from 'common/utils/helpers';

import {
    ENABLED_EDITION,
    ENABLED_EDITION_FAILURE,
    ENABLED_EDITION_SUCCESS,
} from '../actionTypes';
import { panelLayoutV2Actions } from '../reducer';

import fetchParentFieldSegment from './fetchParentFieldSegment';
import setIsDisabledEdition from './setIsDisabledEdition';

export default (layoutId, proposalId) => (dispatch) => {
    dispatch(panelLayoutV2Actions[ENABLED_EDITION]());

    enableEditionProposal(proposalId)
        .then(() => {
            dispatch(panelLayoutV2Actions[ENABLED_EDITION_SUCCESS]());
            dispatch(setIsDisabledEdition(false));
            dispatch(fetchParentFieldSegment(layoutId));
        })
        .catch((error) => {
            dispatch(
                panelLayoutV2Actions[ENABLED_EDITION_FAILURE](
                    error?.response?.data?.errors,
                ),
            );
            showReponseErrorsAsAlert(dispatch, error.response);
        });
};
